<template>
  <div v-if="model" class="mt-2 row g-3 align-items-baseline">
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputFechaRechazo">{{ $t("empresa_agentes.rechazo.fecha") }}</label>
      <div class="mt-1" id="inputFechaRechazo">{{ fechaFormateada }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputUsuarioRechazo">{{ $t("empresa_agentes.rechazo.usuario") }}</label>
      <div class="mt-1" id="inputUsuarioRechazo">{{ model.NombreUsuarioRechazo ?? "-" }}</div>
    </div>
    <div class="form-group col-md-12">
      <label class="dx-field-item-label-text" for="inputMotivoRechazo">{{ $t("empresa_agentes.rechazo.motivo_detalle") }}</label>
      <div class="mt-1 motivo-rechazo" id="inputMotivoRechazo">{{ model.MotivoRechazo ?? "-" }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { DetailEmpresaAgentesModel } from "@/.shared/.api";
import { useIntl } from "@/.shared/services/i18n/i18nservice";

const props = defineProps({
  model: {
    type: Object as () => DetailEmpresaAgentesModel,
    required: true,
  },
});

const intl = useIntl();

const fechaFormateada = computed(() => {
  const fecha = props.model.FechaRechazo;
  if (fecha == null) {
    return "";
  }
  return new Intl.DateTimeFormat(intl.getCurrentLocale(), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(fecha as Date));
});
</script>

<style lang="scss" scoped>
.motivo-rechazo {
  white-space: pre-wrap;
}
</style>
